<template>
  <div class="button-pagetop">
		<a v-scroll-to="'#app'" class="icon"><img src="@/assets/images/icon_pagetop.png" alt=""></a>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

export default {
  name: 'button-pagetop'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.button-pagetop{
	width: 100%;
	.icon {
		display: block;
		width: 40px;
		margin-left: auto;
		cursor: pointer;
		img {
			width: 100%;
		}
	}
}
</style>
